export default __webpack_public_path__ + "static/media/back.b32d8794.svg";